import React, { memo } from 'react';

import { defaultSize, sizePropsTypes } from './icons.constants';

const MicOffIcon = ({ size = defaultSize, ...props }) => (
  <svg
    fill="none"
    height={size}
    viewBox="0 0 24 24"
    width={size}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M3.70711 2.29289C3.31658 1.90237 2.68342 1.90237 2.29289 2.29289C1.90237 2.68342 1.90237 3.31658 2.29289 3.70711L20.2929 21.7071C20.6834 22.0976 21.3166 22.0976 21.7071 21.7071C22.0976 21.3166 22.0976 20.6834 21.7071 20.2929L3.70711 2.29289Z"
      fill="currentColor"
    />
    <path
      d="M15 9.17157V6C15 4.34315 13.6569 3 12 3C10.6938 3 9.58341 3.83481 9.17157 5L15 9.17157Z"
      fill="currentColor"
    />
    <path
      d="M9 9.82843V12C9 13.6569 10.3431 15 12 15C12.3506 15 12.6871 14.9398 13 14.8293L9 9.82843Z"
      fill="currentColor"
    />
    <path
      d="M6 11C6.55228 11 7 11.4477 7 12C7 14.7614 9.23858 17 12 17C12.7286 17 13.4216 16.8451 14.0472 16.5663L15.5167 18.0357C14.8118 18.4583 14.0276 18.7615 13 18.9291V20H15C15.5523 20 16 20.4477 16 21C16 21.5523 15.5523 22 15 22H9C8.44772 22 8 21.5523 8 21C8 20.4477 8.44772 20 9 20H11V18.9291C7.60771 18.4439 5 15.5265 5 12C5 11.4477 5.44772 11 6 11Z"
      fill="currentColor"
    />
    <path
      d="M18.9291 13C18.7956 13.9341 18.4585 14.8064 17.9646 15.5663L19.4006 17.0023C20.2202 15.8533 20.7726 14.4862 20.9591 13H18.9291Z"
      fill="currentColor"
    />
  </svg>
);

MicOffIcon.propTypes = {
  ...sizePropsTypes,
};

export default memo(MicOffIcon);
